export enum LocationInputMode {
  DEFAULT = 'DEFAULT',
  MAP = 'MAP',
  ROUTE_SIGN = 'ROUTE_SIGN',
}
